// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__27T55","content":"Loader_content__wqiDn","iconWrapper":"Loader_iconWrapper__1OyT-","info":"Loader_info__1UjdD","row":"Loader_row__3H2Jk"};